import React from 'react'
import {useSelector} from 'react-redux'
import {ALERTS_ROUTE} from 'constants/index'

import {selectIsAuthenticated} from '@vio/core/src/auth/modules/selectors'
import {MyListHeaderLink} from '@vio/shared/src/priceWatch/components/MyListHeaderLink'
import {MyListLinkComponent} from '@vio/shared/src/priceWatch/hooks/useTrackMyListLinkClick'

interface Props {
  component: MyListLinkComponent
  iconOnly?: boolean
  variant?: 'ghost' | 'ghostInverse'
  isEligible?: boolean
}

export const MyListHeaderEntry = ({
  component,
  iconOnly,
  variant,
  isEligible
}: Props) => {
  const isAuthenticated = useSelector(selectIsAuthenticated)

  return (
    <MyListHeaderLink
      href={ALERTS_ROUTE}
      isAuthenticated={Boolean(isAuthenticated)}
      component={component}
      iconOnly={iconOnly}
      variant={variant}
      isEligible={isEligible}
    />
  )
}
